import {isMatchActive, statuses} from "business/matching"
import CtaButton from "components/redesign/CtaButton"
import _, {find} from 'lodash'
import React, {useState} from 'react'
import {useTranslation} from "react-i18next";

const MenteeMatchSubmitButton = ({matches, submit}) => {
  const {t} = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const allMatchesMade = !_.find(matches, match => match.status === statuses.ACTIVE && !_.get(match, 'interestStatus', false));
  const atleastOneMatchMade = _.find(matches, match => _.get(match, 'interestStatus', false));
  const anyActiveMatch = find(matches, isMatchActive);

  if (!atleastOneMatchMade || !anyActiveMatch) {
    return null;
  }

  return (
    <CtaButton
      size={'large'}
      className={'matching-submit'}
      label={allMatchesMade ? t('confirmChoices') : t('takeActionOnAllMatches')}
      disabled={!allMatchesMade}
      loading={isSubmitting}
      onClick={() => {
        setIsSubmitting(true);
        submit();
      }}/>
  )
}

export default MenteeMatchSubmitButton
